export const VAULTING_SERVICE_VAULT_PATH = '/vaulting-portal/v1/vault';
export const VAULTING_SERVICE_SINGLE_VAULT_REQUEST_PATH =
  '/vaulting-portal/v1/vault-request/{uuid}';
export const VAULTING_SERVICE_SINGLE_HYPERLINK_PATH =
  '/vaulting-portal/v1/hyperlink/{uuid}';
export const VAULTING_SERVICE_HYPERLINKS_PATH =
  '/vaulting-portal/v1/hyperlinks';
export const VAULTING_SERVICE_CONTACT_LIST_SEARCH_PATH =
  '/vaulting-portal/v1/contacts/search';
export const VAULTING_SERVICE_CONTACTS_PATH = '/vaulting-portal/v1/contacts';
export const VAULTING_SERVICE_SINGLE_BUYER_CONTACT_PATH =
  '/vaulting-portal/v1/contact/{uuid}';
export const VAULTING_SERVICE_VAULT_REQUEST_LIST_SEARCH_PATH =
  '/vaulting-portal/v1/vault-requests/search';
export const VAULTING_SERVICE_VAULT_REQUESTS_PATH =
  '/vaulting-portal/v1/vault-requests';
export const VAULTING_SERVICE_BUYER_RECORDS_PATH =
  '/vaulting-portal/v1/auto-complete/buyer';
export const VAULTING_SERVICE_SUPPLIER_RECORDS_PATH =
  '/vaulting-portal/v1/auto-complete/supplier';
export const VAULTING_SERVICE_USER_ACT_LIST_SEARCH_PATH =
  '/vaulting-portal/v1/acts/user';
export const VAULTING_SERVICE_VAULT_ACT_LIST_SEARCH_PATH =
  '/vaulting-portal/v1/acts/vault';
export const VAULTING_SERVICE_SUPPLIER_SECRETS_PATH =
  '/vaulting-portal/v1/secrets/{uuid}';
